import script from "./NavSider.vue?vue&type=script&setup=true&lang=js"
export * from "./NavSider.vue?vue&type=script&setup=true&lang=js"

import "./NavSider.vue?vue&type=style&index=0&id=43971633&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43971633"]])

export default __exports__